module.exports = __webpack_public_path__ + "VIPM3.png?e111ae91e12052c8db896e228cc52812";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM3.png
// module id = 148
// module chunks = 0